import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '../services';

export const adminGuard: CanActivateFn = () => {
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  if (currentUserService.user()?.roles.includes('ADMIN')) {
    return true;
  }

  return router.parseUrl('/not-found');
};
